import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";

export default function IhracEdilenler() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/memur/ihrac-edilenler").then((r) => { setList(r.data); setLoading(false); });
  }, []);

  if (loading) return <div className="p-10 text-zinc-500 font-mono text-sm">YÜKLENİYOR...</div>;

  return (
    <div className="p-6 md:p-10 space-y-6 max-w-5xl">
      <header>
        <div className="text-[11px] font-mono text-rose-500 tracking-widest mb-2">// POLİS DEPARTMANI</div>
        <h1 className="font-heading text-4xl font-bold tracking-tight">İhraç Edilenler</h1>
        <p className="text-zinc-500 mt-2">Memur kadrosundan çıkarılanların kaydı.</p>
      </header>

      <Card className="bg-zinc-950 border-zinc-900 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-zinc-900/50">
              <tr className="text-left text-[10px] font-mono text-zinc-500 tracking-widest">
                <th className="px-4 py-3">İHRAÇ EDİLEN</th>
                <th className="px-4 py-3">İHRAÇ EDEN</th>
                <th className="px-4 py-3">SEBEP</th>
                <th className="px-4 py-3">TARİH</th>
              </tr>
            </thead>
            <tbody>
              {list.map((i) => (
                <tr key={i.id} className="border-t border-zinc-900 hover:bg-zinc-900/40" data-testid={`ihrac-row-${i.id}`}>
                  <td className="px-4 py-3">
                    <div className="font-medium">{i.officer_ic_isim}</div>
                    <div className="text-xs text-zinc-500 font-mono">@{i.officer_discord_username}</div>
                  </td>
                  <td className="px-4 py-3 text-zinc-400">{i.kicked_by_name}</td>
                  <td className="px-4 py-3 text-zinc-400">{i.reason}</td>
                  <td className="px-4 py-3 text-xs text-zinc-500 font-mono">{new Date(i.created_at).toLocaleString("tr-TR")}</td>
                </tr>
              ))}
              {list.length === 0 && (
                <tr><td colSpan={4} className="px-4 py-10 text-center text-zinc-500">Henüz ihraç kaydı yok.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
